export default function initStaggerList(page) {
  page.querySelectorAll('[data-css-animation="stagger-list"]').forEach(list => {
    const delay = getComputedStyle(list).getPropertyValue('--delay') || 0
    list
      .querySelectorAll('[data-css-animation^="stagger-item"]')
      .forEach((item, i) => {
        item.style.setProperty('--delay', `${parseFloat(delay) + i / 10}s`)
      })
  })
}
